import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { AdornisUser } from '@adornis/users/db/a-user.js';
import { createNewUser } from '@adornis/users/server/util.js';
import { ExpectedError } from '@adornis/validation/errors/ExpectedError.js';
import { assertCanManageUsers } from '../server/access.js';
import { sendPasswordMail } from '../server/sendPasswordMail.js';

/**
 * Create an account and mail it a one-time link to set its password — createNewUser gets
 * no password, so it assigns a random one nobody learns.
 *
 * @returns the address the invitation went to
 */
export const inviteUser = registerMutation({
  type: () => String,
  operationName: 'inviteUser',
  resolve: (email: string, username: string) => {
    return async () => {
      await assertCanManageUsers();

      const trimmedEmail = email.trim();
      const trimmedUsername = username.trim() || trimmedEmail;
      if (!trimmedEmail) throw new ExpectedError('Bitte eine E-Mail-Adresse angeben.');

      // createNewUser rejects duplicate e-mails and usernames itself.
      const userID = await createNewUser(new AdornisUser({ username: trimmedUsername, email: trimmedEmail }));

      // The account exists from here on. If the mail fails, say so plainly — the admin can
      // resend from the list rather than being left with a silently unusable account.
      await sendPasswordMail(userID, trimmedEmail, { isInvitation: true });
      return trimmedEmail;
    };
  },
  params: [
    { name: 'email', type: () => String },
    { name: 'username', type: () => String },
  ],
});
